import { render, staticRenderFns } from "./CoAdminBookingResourceCreateEdit.vue?vue&type=template&id=07faf0f7&"
import script from "./CoAdminBookingResourceCreateEdit.vue?vue&type=script&lang=ts&"
export * from "./CoAdminBookingResourceCreateEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports